import { render, staticRenderFns } from "./numbers-list-badge-counter.vue?vue&type=template&id=6c04e69c&"
import script from "./numbers-list-badge-counter.vue?vue&type=script&lang=js&"
export * from "./numbers-list-badge-counter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports